import React, { SyntheticEvent } from "react";
import { formatSequencial } from "@tvg/formatter";
import { question } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons";
// $FlowFixMe
import Button from "@fdr/atomic-ui/_atoms/Button";
import { RunnerTagsWrapper, RunnerTag } from "./styled-components";

interface Tag {
  tag: string;
  text: string;
}

interface Props {
  /**
   * Add margin in case of showing the silks
   */
  hasTimeformInfo?: boolean;
  /**
   * Number fire predict label
   */
  numberFire?: number;
  /**
   * Runner tags to render as normal label
   */
  tags?: Tag[];
  /**
   * Custom qa label
   */
  qaLabel?: string;
  /**
   * On runner tags tooltip click
   */
  onRaceTagsInfoClick?: Function;
  /**
   * Runner info is expanded
   */
  isOpen?: boolean;
}

const RunnerTags = ({
  hasTimeformInfo,
  numberFire,
  tags = [],
  qaLabel = "runnerTags",
  onRaceTagsInfoClick,
  isOpen
}: Props) => (
  <RunnerTagsWrapper hasTimeformInfo={hasTimeformInfo} data-qa-label={qaLabel}>
    {numberFire && (
      <RunnerTag
        pickNumber={numberFire}
        data-qa-label={`${qaLabel}-${numberFire}`}
      >
        {formatSequencial(numberFire)} Pick
      </RunnerTag>
    )}
    {tags.map(({ tag, text }) => (
      <RunnerTag key={tag} data-qa-label={`${qaLabel}-${tag}`}>
        {text}
      </RunnerTag>
    ))}

    {!!tags.length && !!isOpen && (
      <Button
        type="secondary"
        size="noSize"
        onClick={(e: SyntheticEvent) => {
          e.preventDefault();
          e.stopPropagation();
          if (onRaceTagsInfoClick) onRaceTagsInfoClick();
        }}
        qaLabel="betConfirmation-loginBtn"
        paddingLess
        borderLess
      >
        <Icon icon={question} color={buildColor("blue", "D1")} size={16} />
      </Button>
    )}
  </RunnerTagsWrapper>
);

export default RunnerTags;
